<template>
  <v-dialog v-model="open" width="500" :persistent="persistent">
    <v-card>
      <v-card-title
        v-if="title !== ''"
        class="headline lighten-1"
        style="color: white;"
        primary-title
      >
        {{ title }}
      </v-card-title>

      <v-card-text>
        {{ message }}
      </v-card-text>

      <v-card-actions v-if="!persistent">
        <bxp-button color="lightgrey" @click="closeDialog">
          Got it
        </bxp-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    computed: {
      open() {
        return this.$formFrameworkOptions.formBus.notice.open;
      },
      message() {
        return this.$formFrameworkOptions.formBus.notice.message;
      },
      title() {
        return this.$formFrameworkOptions.formBus.notice.title;
      },
      persistent() {
        return this.$formFrameworkOptions.formBus.notice.persistent;
      }
    },
    methods: {
      closeDialog() {
        this.$formFrameworkOptions.formBus.notice.open = false;
        this.$formFrameworkOptions.formBus.notice.message = "";
        this.$formFrameworkOptions.formBus.notice.title = "";
        this.$formFrameworkOptions.formBus.notice.persistent = false;
      }
    }
  }
</script>

<style scoped>
  .headline {
    background-color: var(--v-secondary-base);
    padding: 12px 16px;
  }
  .v-card__text {
    padding: 20px 16px !important;
    font-size: 15px;
  }
</style>
